export enum CheckOutResponseType {
  CCAuthFailed = 0,
  SOCreated = 1,
  FailedToCreateSO = 2,
  NeedsApproval = 3,
  ApprovedNeedsApproval = 4,
  PreventCheckout = 5,
  Rejected = 6,
  AlreadyReviewed = 7,
  CurrentlyBeingReviewed = 8,
  EmptyCart = 9,
  CartNotSubmitted = 10,
  InvalidCoupon = 11,
  DeliveryChargeChanged = 12,
}
